var FitableSupport = require("enyo-ui/FitableSupport"),
    kind           = require("enyo/kind"),
    themeVars      = require("app/theme/ImageReaderPageThumbnailPlaceholderVariables");

require("./PageThumbnailPlaceholder.less");

module.exports = kind(/** @lends  app.MediaPlayer.Tech.ImageReader.PageThumbnailPlaceholder.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageReader.PageThumbnailPlaceholder",

    /**
     * @private
     */
    classes: "app-media-player-image-reader-page-thumbnail-placeholder",

    /**
     * @private
     */
    mixins: [
        FitableSupport
    ],

    /**
     * Whether to display a title below the image
     *
     * @type  {boolean}
     * @public
     */
    showTitle: true,

    /**
     * The aspect ratio of the thumbnail.
     *
     * @type     {number}
     * @default  1
     * @public
     */
    ratio: 1,

    /**
     * @private
     */
    components: [{
        classes: "app-media-player-image-reader-page-thumbnail-placeholder__image"
    }, {
        classes: "app-media-player-image-reader-page-thumbnail-placeholder__title"
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".repeater.showItemTitles",
        to:   ".showTitle",

        /**
         * If the repeater does not provide any info, just show the current
         * value.
         *
         * @param   {boolean|undefined} showTitle Possible setting passed from
         *                                        repeater.
         * @return  {boolean} Whether to show the title
         * @private
         */
        transform: function(showTitle) {
            if (showTitle === undefined) {
                return this.showTitle;
            }
            else {
                return showTitle;
            }
        }
    }, {
        from: ".showTitle",
        to:   ".$.title.showing"
    }],

    /**
     * Calculates the width.
     *
     * @param   {number}  height  The height
     * @return  {number}  The width.
     * @public
     */
    calcWidth: function(height) {
        if (this.showTitle) {
            return (height - themeVars.getTitleHeightPx()) * this.ratio;
        }
        else {
            return height * this.ratio;
        }
    },

    /**
     * Calculates the height.
     *
     * @param   {number}  width  The width
     * @return  {number}  The height.
     * @public
     */
    calcHeight: function(width) {
        if (this.showTitle) {
            return width / this.ratio + themeVars.getTitleHeightPx();
        }
        else {
            return width / this.ratio;
        }
    }

});
